module.exports = __webpack_public_path__ + "static/media/avatar.a081c009.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/avatar.svg
// module id = 3360
// module chunks = 6